<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 操作按钮区域 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button 
              type="primary" 
              size="medium" 
              class="action-btn primary-btn"
              @click="addButton()">
              <i class="el-icon-plus"></i>
              添加参数
            </el-button>
          </div>
        </div>

        <!-- 搜索区域 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <div class="search-content">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <div class="form-row">
                <div class="form-item">
                  <label class="form-label">参数名称</label>
                  <div class="input-wrapper">
                    <el-input 
                      v-model="searchCondition.param_key" 
                      placeholder="输入参数名称"
                      prefix-icon="el-icon-key"
                      clearable>
                    </el-input>
                  </div>
                </div>
                <div class="form-item" style="margin-left: 20px;">
                  <div class="button-group">
                    <el-button 
                      type="primary" 
                      size="medium"
                      class="search-btn"
                      @click="searchButton">
                      <i class="el-icon-search"></i>
                      查询
                    </el-button>
                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-card">
          <div class="table-header">
            <h3 class="table-title">
              <i class="el-icon-s-grid"></i>
              参数列表
            </h3>
            <div class="table-tools">
              <span class="data-count">共 {{list.length}} 条数据</span>
            </div>
          </div>
          <div class="table-content">
            <div class="modern-table">
              <ApeTable ref="apeTable" :data="list"  :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
                <el-table-column
                  width="64"
                  label="序号"
                  align="center">
                  <template slot-scope="scope">
                    <div class="serial-number">{{offset+scope.$index+1}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="参数信息"
                  min-width="300">
                  <template slot-scope="scope">
                    <div class="param-cell">
                      <div class="param-key">
                        <i class="el-icon-key"></i>
                        {{scope.row.param_key}}
                      </div>
                      <div class="param-desc" v-if="scope.row.param_desc">
                        <i class="el-icon-document"></i>
                        {{scope.row.param_desc}}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="参数值"
                  min-width="200">
                  <template slot-scope="scope">
                    <div class="param-value">
                      <div class="value-display" @click="showValueDetail(scope.row.param_value)">
                        <span class="value-text">{{getDisplayValue(scope.row.param_value)}}</span>
                        <el-button 
                          v-if="scope.row.param_value && scope.row.param_value.length > 50"
                          type="text" 
                          size="mini" 
                          class="view-more-btn">
                          <i class="el-icon-view"></i>
                        </el-button>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="buttonType=='icon'"
                  width="160"
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <div class="action-cell">
                      <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <el-button 
                          size="mini" 
                          type="primary"
                          icon="el-icon-edit" 
                          class="table-action-btn edit-btn"
                          @click="editButton(scope.row.id)">
                        </el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除" placement="top-start">
                        <el-popconfirm
                          title="确定删除这个参数吗？"
                          @confirm="deleteButton(scope.row.id)">
                          <el-button
                            slot="reference"
                            size="mini"
                            type="danger"
                            icon="el-icon-delete"
                            class="table-action-btn delete-btn">
                          </el-button>
                        </el-popconfirm>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </ApeTable>
            </div>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="96px">
          <el-form-item label="参数名称" prop="param_key">
            <el-input v-model="formData.param_key"></el-input>
          </el-form-item>
          <el-form-item label="参数值" prop="param_value">
            <div class="param-value-container">
              <div class="param-value-toolbar">
                <el-button 
                  size="mini" 
                  type="primary" 
                  icon="el-icon-magic-stick"
                  @click="formatJson"
                  :disabled="!formData.param_value">
                  格式化JSON
                </el-button>
                <el-button 
                  size="mini" 
                  type="success" 
                  icon="el-icon-check"
                  @click="validateJson"
                  :disabled="!formData.param_value">
                  验证JSON
                </el-button>
                <el-button 
                  size="mini" 
                  type="info" 
                  icon="el-icon-refresh"
                  @click="clearJson">
                  清空
                </el-button>
                <span class="json-status" :class="jsonStatusClass">
                  <i :class="jsonStatusIcon"></i>
                  {{jsonStatusText}}
                </span>
              </div>
              <el-input 
                v-model="formData.param_value" 
                type="textarea"
                :rows="10"
                placeholder="请输入参数值，支持JSON格式数据"
                resize="vertical"
                class="param-value-textarea"
                @input="onParamValueChange">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="备注" prop="param_desc">
            <el-input v-model="formData.param_desc"></el-input>
          </el-form-item>
        </el-form>        
      </template>
    </ModalDialog>

    <!-- 参数值详情弹窗 -->
    <el-dialog
      title="参数值详情"
      :visible.sync="valueDetailVisible"
      width="60%"
      :before-close="closeValueDetail">
      <div class="value-detail-content">
        <div class="value-header">
          <span class="value-label">完整参数值：</span>
          <el-button 
            type="primary" 
            size="mini" 
            @click="copyValue"
            class="copy-btn">
            <i class="el-icon-document-copy"></i>
            复制
          </el-button>
        </div>
        <div class="value-content">
          <el-input
            v-model="currentValue"
            type="textarea"
            :rows="12"
            readonly
            class="value-textarea">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeValueDetail">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog,
    ApeUploader
  },
  data() {
    return {
      uploadHeaders:{},
      searchCondition:{
        "param_key":'',
        "current_page": 1,
        "page_size": 20,
        "query":"",
        "params":[]
      },
      loadingStaus: true,
      uploadFileList:[],
      // 表格列表数据
      list:[],
      // 分页信息
       pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 20,
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 表单结构
      formData: {
        id:0
      },
      rules: {
        
      },
      funcPosition:[
        {
          label:'执行模版前',
          value:'0'
        },
        {
          label:'执行模版中',
          value:'1'
        },
        {
          label:'执行模版后',
          value:'1'
        },
      ],
      // 抽屉数据
      dialogData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '100%',
      },
      // 参数值详情弹窗数据
      valueDetailVisible: false,
      currentValue: '',
      // JSON格式化相关数据
      jsonStatus: 'none', // none, valid, invalid, formatting
      jsonStatusText: '未验证',
      jsonStatusIcon: 'el-icon-question',
      jsonStatusClass: 'json-status-none',
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    // 搜索
    searchButton() {
      this.initList()
    },
    // 切换页码操作
    async switchPaging() {
      this.initList()
    },
    // 响应添加按钮
    async addButton() {
      this.formData = {}
      this.formData.id = 0
      this.dialogData.visible = true
      this.dialogData.title = '添加参数'
      this.dialogData.loading = false
      this.dialogData.eidit=false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.dialogData.loading_text = '玩命加载中……'
      this.dialogData.visible = true
      this.dialogData.title = '编辑目标(UID：'+id+')'
      let res = await this.$api.post('/service/system_params/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }
      this.dialogData.loading = false
    },

    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.dialogData.visible = false
      this.dialogData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['ApeDrawerForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      this.dialogData.loading_text = '玩命提交中……'
      this.dialogData.loading = true
      let url = '/service/system_params/create'
      if(this.formData.id !=''){
         url = '/service/system_params/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.$message.success('保存成功!')
        this.initList()
      }
      this.initFormData()
    },
    // 相应删除按钮
    async deleteButton(id) {
      try {
        // 显示确认对话框
        const confirmResult = await this.$confirm(
          '此操作将永久删除该参数，是否继续？',
          '删除确认',
          {
            confirmButtonText: '确定删除',
            cancelButtonText: '取消',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            customClass: 'delete-confirm-dialog'
          }
        ).catch(() => {
          // 用户取消删除
          return false
        })
        
        if (!confirmResult) return
        
        // 显示删除进度
        const loadingInstance = this.$loading({
          lock: true,
          text: '正在删除参数...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        
        try {
          let res = await this.$api.post('/service/system_params/delete', {id: id})
          
          if (this.$apiSuccess(res)) {
            this.$message.success('参数删除成功！')
            this.initList()
          } else {
            this.$message.error(res.msg || '删除失败，请重试')
          }
        } catch (error) {
          console.error('删除参数失败:', error)
          this.$message.error('删除失败：' + (error.message || '网络错误，请重试'))
        } finally {
          loadingInstance.close()
        }
      } catch (error) {
        console.error('删除操作异常:', error)
        this.$message.error('删除操作失败，请重试')
      }
    },
     // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initFormData()
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.$refs['dataForm'].resetFields()
      })
    },
    // 获取显示值（截取前50个字符）
    getDisplayValue(value) {
      if (!value) return ''
      if (value.length <= 50) return value
      return value.substring(0, 50) + '...'
    },
    // 判断是否为JSON格式
    isJsonString(str) {
      if (!str || typeof str !== 'string') return false
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
    },
    // 格式化JSON字符串
    formatJsonString(str) {
      if (!this.isJsonString(str)) return str
      try {
        return JSON.stringify(JSON.parse(str), null, 2)
      } catch (e) {
        return str
      }
    },
    // 显示参数值详情
    showValueDetail(value) {
      // 如果是JSON格式，进行格式化
      this.currentValue = this.formatJsonString(value || '')
      this.valueDetailVisible = true
    },
    // 关闭参数值详情
    closeValueDetail() {
      this.valueDetailVisible = false
      this.currentValue = ''
    },
    // 复制参数值
    copyValue() {
      if (this.currentValue) {
        navigator.clipboard.writeText(this.currentValue).then(() => {
          this.$message.success('复制成功！')
        }).catch(() => {
          // 降级方案
          const textArea = document.createElement('textarea')
          textArea.value = this.currentValue
          document.body.appendChild(textArea)
          textArea.select()
          document.execCommand('copy')
          document.body.removeChild(textArea)
          this.$message.success('复制成功！')
        })
      }
    },
    
    // JSON格式化相关方法
    // 格式化JSON
    formatJson() {
      if (!this.formData.param_value) {
        this.$message.warning('请输入要格式化的内容')
        return
      }
      
      try {
        // 先验证是否为有效JSON
        const parsed = JSON.parse(this.formData.param_value)
        // 格式化JSON
        this.formData.param_value = JSON.stringify(parsed, null, 2)
        this.updateJsonStatus('valid', 'JSON格式正确', 'el-icon-success', 'json-status-valid')
        this.$message.success('JSON格式化成功！')
      } catch (error) {
        this.updateJsonStatus('invalid', 'JSON格式错误', 'el-icon-error', 'json-status-invalid')
        this.$message.error('JSON格式错误：' + error.message)
      }
    },
    
    // 验证JSON
    validateJson() {
      if (!this.formData.param_value) {
        this.$message.warning('请输入要验证的内容')
        return
      }
      
      try {
        JSON.parse(this.formData.param_value)
        this.updateJsonStatus('valid', 'JSON格式正确', 'el-icon-success', 'json-status-valid')
        this.$message.success('JSON格式验证通过！')
      } catch (error) {
        this.updateJsonStatus('invalid', 'JSON格式错误', 'el-icon-error', 'json-status-invalid')
        this.$message.error('JSON格式错误：' + error.message)
      }
    },
    
    // 清空JSON
    clearJson() {
      this.$confirm('确定要清空参数值吗？', '清空确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.param_value = ''
        this.updateJsonStatus('none', '未验证', 'el-icon-question', 'json-status-none')
        this.$message.success('已清空参数值')
      }).catch(() => {
        // 用户取消
      })
    },
    
    // 参数值变化时的处理
    onParamValueChange(value) {
      if (!value || value.trim() === '') {
        this.updateJsonStatus('none', '未验证', 'el-icon-question', 'json-status-none')
        return
      }
      
      // 自动检测JSON格式
      try {
        JSON.parse(value)
        this.updateJsonStatus('valid', 'JSON格式正确', 'el-icon-success', 'json-status-valid')
      } catch (error) {
        this.updateJsonStatus('invalid', 'JSON格式错误', 'el-icon-error', 'json-status-invalid')
      }
    },
    
    // 更新JSON状态
    updateJsonStatus(status, text, icon, className) {
      this.jsonStatus = status
      this.jsonStatusText = text
      this.jsonStatusIcon = icon
      this.jsonStatusClass = className
    },

    // 初始化目标列表
    async initList() {
      this.loadingStaus=true
      this.searchCondition.params=[]
      this.searchCondition.query = ''
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      // 实现对量合并
      Object.assign(this.searchCondition,pagingInfo)
      if(this.searchCondition.param_key != ''){
        this.searchCondition.query = 'instr(param_key,?)'
        this.searchCondition.params.push(this.searchCondition.param_key)
      }
      let res = await this.$api.post('/service/system_params/list',this.searchCondition)
      if (this.$apiSuccess(res)){
        this.list = res.data.list
        this.pagingData.total = res.data.page.total
      }
      this.loadingStaus=false
    }
  },
  mounted() {
    this.initList()
  },
}
</script>

<style lang="stylus" scoped>
.main-page-content
  padding 0
  
// 页面标题区域
.page-title-section
  background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
  padding 32px
  margin-bottom 24px
  border-radius 12px
  color #fff
  
  .title-content
    .page-title
      font-size 28px
      font-weight 600
      margin 0 0 8px 0
      display flex
      align-items center
      gap 12px
      
      i
        font-size 32px
        opacity 0.9
        
    .page-subtitle
      font-size 16px
      opacity 0.9
      margin 0

// 操作卡片
.action-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .action-header
    margin-bottom 16px
    
    .action-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      height 40px
      padding 0 20px
      border-radius 8px
      font-weight 500
      transition all 0.3s ease
      
      &.primary-btn
        background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
        border none
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
        &:hover
          transform translateY(-2px)
          box-shadow 0 6px 16px rgba(64,158,255,0.4)

// 搜索卡片
.search-card
  background #fff
  border-radius 12px
  padding 24px
  margin-bottom 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .search-header
    margin-bottom 20px
    border-bottom 1px solid #f0f0f0
    padding-bottom 12px
    
    .search-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
  .search-content
    .search-form
      .form-row
        display flex
        flex-wrap wrap
        gap 16px
        align-items flex-end
        
        .form-item
          flex none
          margin-bottom 16px
          
          .form-label
            display block
            font-size 14px
            color #606266
            margin-bottom 8px
            font-weight 500
            
          .input-wrapper
            /deep/ .el-input
              width 200px
              
              .el-input__inner
                border-radius 8px
                border 2px solid #f0f0f0
                transition all 0.3s ease
                
                &:focus
                  border-color #409EFF
                  box-shadow 0 0 0 2px rgba(64,158,255,0.1)
                  
          .button-group
            display flex
            gap 8px
            
            .search-btn
              background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
              border none
              border-radius 8px
              padding 10px 20px
              font-weight 500
              box-shadow 0 2px 8px rgba(64,158,255,0.3)
              
              &:hover
                transform translateY(-1px)
                box-shadow 0 4px 12px rgba(64,158,255,0.4)

// 表格卡片
.table-card
  background #fff
  border-radius 12px
  padding 24px
  box-shadow 0 2px 12px rgba(0,0,0,0.1)
  border 1px solid #f0f0f0
  
  .table-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .table-title
      font-size 16px
      font-weight 600
      color #303133
      margin 0
      display flex
      align-items center
      gap 8px
      
      i
        color #409EFF
        
    .table-tools
      .data-count
        color #909399
        font-size 14px

// 表格样式
.modern-table
  /deep/ .el-table
    border-radius 8px
    overflow hidden
    
    .el-table__header
      background #f8f9fa
      
      th
        background #f8f9fa !important
        color #303133
        font-weight 600
        border-bottom 2px solid #e4e7ed
        
    .el-table__body
      tr
        transition all 0.3s ease
        
        &:hover
          background-color #f5f7fa
          
        td
          border-bottom 1px solid #f0f0f0

// 表格单元格样式
.serial-number
  font-weight 600
  color #606266
  background #f8f9fa
  padding 4px 8px
  border-radius 4px
  display inline-block
  min-width 28px
  text-align center

.param-cell
  .param-key
    font-size 16px
    font-weight 600
    color #303133
    margin-bottom 6px
    display flex
    align-items center
    gap 8px
    
    i
      color #409EFF
      
  .param-desc
    font-size 14px
    color #909399
    display flex
    align-items center
    gap 6px
    
    i
      color #67C23A

.param-value
  .value-display
    display flex
    align-items center
    gap 8px
    cursor pointer
    padding 8px 12px
    border-radius 6px
    background #f8f9fa
    transition all 0.3s ease
    
    &:hover
      background #e8f4fd
      border 1px solid #409EFF
      
    .value-text
      flex 1
      color #606266
      font-family 'Monaco', 'Consolas', 'Courier New', monospace
      font-size 13px
      word-break break-all
      line-height 1.4
      
    .view-more-btn
      flex none
      color #409EFF
      padding 4px
      
      &:hover
        color #66B3FF

.action-cell
  display flex
  gap 6px
  justify-content center
  
  .table-action-btn
    width 28px
    height 28px
    border-radius 6px
    padding 0
    display inline-flex
    align-items center
    justify-content center
    transition all 0.3s ease
    
    &.edit-btn
      background #409EFF
      border-color #409EFF
      
      &:hover
        background #66B3FF
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(64,158,255,0.3)
        
    &.delete-btn
      background #F56C6C
      border-color #F56C6C
      
      &:hover
        background #F78989
        transform translateY(-2px)
        box-shadow 0 4px 12px rgba(245,108,108,0.3)

// 参数值详情弹窗样式
.value-detail-content
  .value-header
    display flex
    justify-content space-between
    align-items center
    margin-bottom 16px
    padding-bottom 12px
    border-bottom 1px solid #f0f0f0
    
    .value-label
      font-size 16px
      font-weight 600
      color #303133
      
    .copy-btn
      background linear-gradient(135deg, #409EFF 0%, #66B3FF 100%)
      border none
      border-radius 6px
      padding 8px 16px
      font-weight 500
      box-shadow 0 2px 8px rgba(64,158,255,0.3)
      
      &:hover
        transform translateY(-1px)
        box-shadow 0 4px 12px rgba(64,158,255,0.4)
      
  .value-content
    .value-textarea
      /deep/ .el-textarea__inner
        font-family 'Monaco', 'Consolas', 'Courier New', monospace
        font-size 13px
        line-height 1.5
        background #f8f9fa
        border 1px solid #e4e7ed
        border-radius 8px
        resize vertical

// JSON格式化相关样式
.param-value-container
  .param-value-toolbar
    display flex
    align-items center
    gap 12px
    margin-bottom 12px
    padding 12px 16px
    background #f8f9fa
    border-radius 8px
    border 1px solid #e4e7ed
    
    .el-button
      height 28px
      padding 0 12px
      font-size 12px
      border-radius 6px
      transition all 0.3s ease
      
      &:hover
        transform translateY(-1px)
        box-shadow 0 2px 8px rgba(0,0,0,0.15)
        
      &:disabled
        opacity 0.6
        cursor not-allowed
        transform none
        box-shadow none
    
    .json-status
      margin-left auto
      display flex
      align-items center
      gap 6px
      font-size 12px
      font-weight 500
      padding 4px 8px
      border-radius 4px
      transition all 0.3s ease
      
      i
        font-size 14px
        
      &.json-status-none
        color #909399
        background #f4f4f5
        
      &.json-status-valid
        color #67C23A
        background #f0f9ff
        border 1px solid #b3e19d
        
      &.json-status-invalid
        color #F56C6C
        background #fef0f0
        border 1px solid #fbc4c4
        
  .param-value-textarea
    /deep/ .el-textarea__inner
      font-family 'Monaco', 'Consolas', 'Courier New', monospace
      font-size 13px
      line-height 1.6
      background #fff
      border 2px solid #e4e7ed
      border-radius 8px
      transition all 0.3s ease
      resize vertical
      
      &:focus
        border-color #409EFF
        box-shadow 0 0 0 2px rgba(64,158,255,0.1)
        
      &::placeholder
        color #c0c4cc
        font-style italic

// 删除确认对话框样式
/deep/ .delete-confirm-dialog
  .el-message-box__header
    background #fff5f5
    border-bottom 1px solid #fde2e2
    
  .el-message-box__title
    color #f56c6c
    font-weight 600
    
  .el-message-box__content
    padding 20px
    
  .el-message-box__btns
    padding 10px 20px 20px
    
    .el-button--primary
      background #f56c6c
      border-color #f56c6c
      
      &:hover
        background #f78989
        border-color #f78989

// 响应式设计
@media (max-width: 768px)
  .page-title-section
    padding 20px
    
    .title-content
      .page-title
        font-size 24px
        
  .action-card, .search-card, .table-card
    padding 16px
    
  .action-buttons
    flex-direction column
    
    .action-btn
      width 100%
      margin-bottom 8px
      
  .search-content
    .search-form
      .form-row
        flex-direction column
        align-items stretch
        
        .form-item
          width 100%
          
          .input-wrapper
            /deep/ .el-input
              width 100%
</style>
